import React, { PropsWithChildren, useEffect } from 'react'
import styled from 'styled-components'
import { useHistory, useLocation } from 'react-router-dom'
import { connect, useDispatch } from 'react-redux'
import type { AppDispatch } from 'src/client/store'
import { showSnackbar } from 'components/Luxkit/Snackbar/AppSnackbar'
import { EXPERIMENT, startExperiment } from 'lib/optimize'
import PromptCardSelector from 'components/Common/StickyPromptCard/PromptCardSelector'
import { GlobalSearchTrackingProvider } from 'contexts/GlobalSearch/GlobalSearchTracking'
import useHomepageAnalytics from 'home/pages/HomePage/useHomepageAnalytics'

const Root = styled.div`
  /* Workaround for IE11 bug - see https://github.com/philipwalton/flexbugs/issues/75 */
  min-height: 1px;
`

const HOMEPAGE_VERSION = 'old-homepage'

interface MappedProps {
  utmMedium: string | undefined;
  currency: string;
}

function FrontPage(props: PropsWithChildren & MappedProps) {
  const { children, utmMedium, currency } = props
  const dispatch = useDispatch<AppDispatch>()
  const location = useLocation()
  const history = useHistory()

  useEffect(() => {
    if (utmMedium !== 'cpc') {
      startExperiment(EXPERIMENT.HOME_PAGE_LOADED)
      startExperiment(EXPERIMENT.REVIEW_V3_PAGE_LOADED)
    }
  }, [utmMedium])

  useEffect(() => {
    startExperiment(EXPERIMENT.TRENDING_DESTINATION_BY_SALES)
  }, [])

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search)
    if (queryParams.has('emailverified') && queryParams.get('emailverified')) {
      queryParams.delete('emailverified')
      history.replace({
        search: queryParams.toString(),
      })
      showSnackbar(
        'You will now receive the best offers in your inbox',
        'success',
        { heading: 'Congrats! Your email is verified' },
      )
    }
  }, [dispatch, history, location.search])

  const { onSearchEvent } = useHomepageAnalytics(HOMEPAGE_VERSION, currency)

  return (
    <Root className="FrontPage">
      <PromptCardSelector abandonedCart hotLead tripReengagement stickyTop={112} />
      <GlobalSearchTrackingProvider onEvent={onSearchEvent}>
        {children}
      </GlobalSearchTrackingProvider>
    </Root>
  )
}

function mapStateToProps(state: App.State) {
  return {
    utmMedium: state.utm.medium,
    currency: state.geo.currentCurrency,
  }
}

export default connect(mapStateToProps)(FrontPage)
